export const isIndianUser = (country) =>
  typeof country === "string" && country.trim().toLowerCase() === "india";
